import axios from 'axios'
import _ from 'lodash'
import { getGUID, getIp, isSnsLogin, logger, setDisableScrolling } from '@/common/utils/common'
import cookie from '@/common/utils/cookie'
import store from '@/store'
import { SHOW_LOGIN_POPUP } from '@/common/resources/store.type.const'
import constant from '@/common/resources/constant'
import { stringify } from 'query-string'
import {
  PLAYER_UPDATE_EVENT,
  UPDATE,
  PLAY,
  PLAYER_PLAY_EVENT,
  EXPIRED_CREDENTIAL,
  PLAYER_EXPIRED_CREDENTIAL_EVENT
} from '@/common/player.const'
import { isApollo } from '@/common/utils/apollo.interface'

export const PlayerType = {
  INSTANT: 'i',
  MAIN: 'm', // PC Web
  APOLLO: 'apollo', // 아폴로 앱
  MOBILE: 'mobile' // 아폴로 앱이 아닌 외부에서 아폴로 url을 치고 들어간 경우 (실제 쓰이진 않음, 다만 구분을 위해 추가)
}

export const showDownloadLayoutWithContext = (context) => () => {
  if (cookie.hasNotCredential()) {
    store.commit(SHOW_LOGIN_POPUP)
  } else {
    context.downloadLayout = true
    setDisableScrolling(true)
  }
}

let voucherPopup = null
export const showVoucherPopup = ({ type, contentInfo }) => {
  if (cookie.hasNotCredential()) {
    store.commit(SHOW_LOGIN_POPUP)
  } else {
    if (isSnsLogin()) {
      if (!confirm(constant.MSG_VOUCHER_SNS_ALERT)) { return }
    }
    const baseUrl = '/voucher/popup'
    const params = {}
    switch (type) {
      case 'vod':
      case 'voddownload':
        console.log(contentInfo)
        params.type = 'voucher'
        params.contenttype = 'vod'
        params.contentid = _.get(contentInfo, 'contentid', '')
        params.programid = _.get(contentInfo, 'programid', '')
        params.channelid = _.get(contentInfo, 'channelid', '')
        params.cpid = _.get(contentInfo, 'cpid', '')
        if (type === 'voddownload') {
          params.downloadyn = _.get(contentInfo, 'downloadable', 'n')
        }
        break
      case 'movie':
      case 'moviedownload':
        params.type = 'movie'
        params.contenttype = 'movie'
        params.contentid = _.get(contentInfo, 'movieid', '') || _.get(contentInfo, 'contentid', '')
        params.programid = _.get(contentInfo, 'movieid', '') || _.get(contentInfo, 'contentid', '')
        params.channelid = 'none'
        params.cpid = _.get(contentInfo, 'cpid', '')
        params.playy = _.indexOf(_.get(contentInfo, 'moviemarks', []), 'playy') > -1 ? 'y' : 'n'
        if (type === 'moviedownload') {
          params.downloadyn = _.get(contentInfo, 'downloadable', 'n')
        }
        break
      case 'live':
        params.type = 'voucher'
        params.contenttype = 'live'
        params.contentid = _.get(contentInfo, 'channelid', '')
        params.programid = _.get(contentInfo, 'programid', '')
        params.channelid = _.get(contentInfo, 'channelid', '')
        params.cpid = _.get(contentInfo, 'cpid', '')
        break
      case 'clip':
        params.type = 'all'
    }
    voucherPopup = window.open(`${baseUrl}?${stringify(params)}`, '', 'width=700, height=780, scrollbars=yes')
    voucherPopup.focus()
    // if (voucherPopup) {
    //   voucherPopupInterval = setInterval(checkClosePopup, 800)
    // }
  }
}

export const showVoucherPopupWithContext = ({ type, contentInfo }) => () => { showVoucherPopup({ type, contentInfo }) }

export const setPlayerModeDefault = () => {
  if (window.playerInstance) {
    window.playerInstance.setDefaultMode()
  }
}

export function getPlayerClass () {
  if (window.ScalablePlayer) {
    console.log('exist!! return exist player class')
    return new Promise((resolve, reject) => {
      resolve(window.ScalablePlayer)
    })
  } else {
    console.log('not exist!! return new player class')
    const origin = location.origin
    return axios.get(`${origin}/wavveplayer/dist/scalableplayer.lastestversion.json?hash=${Date.now().toString()}`)
      .then(({ data }) => {
        return new Promise((resolve, reject) => {
          // Global Callback
          window.loadedScalablePlayer = function () {
            resolve(window.ScalablePlayer)
          }
          const version = _.get(data, 'lastest_version', '')
          const fragment = document.createDocumentFragment()
          const linkEl = document.createElement('link')
          linkEl.setAttribute('rel', 'stylesheet')
          linkEl.setAttribute('type', 'text/css')
          linkEl.setAttribute('href', `${origin}/wavveplayer/dist/scalableplayer.${version}.css`)
          const jsEl = document.createElement('script')
          jsEl.setAttribute('src', `${origin}/wavveplayer/dist/scalableplayer.${version}.js`)
          jsEl.async = true
          fragment.appendChild(linkEl)
          fragment.appendChild(jsEl)
          const existScriptTab = document.getElementsByTagName('script')[0]
          existScriptTab.parentNode.insertBefore(fragment, existScriptTab)
        })
      })
  }
}

const getPlayerDelegateInstance = (context, callbacks) => {
  delete window.playerDelegate
  class PlayerDelegate {
    constructor (context) {
      this.context = context
      context = null
    }
    onEvent (e, value) {
      switch (e) {
        // case READY:
        // logger('cyan')('READY')
        // this.context.playerInit()
        // break
        case UPDATE:
          logger('cyan')('UPDATE')
          this.context.$events.$emit(PLAYER_UPDATE_EVENT, value)
          break
        case PLAY:
          logger('cyan')('PLAY')
          this.context.$events.$emit(PLAYER_PLAY_EVENT, value)
          break
        case EXPIRED_CREDENTIAL:
          logger('cyan')('EXPIRED_CREDENTIAL')
          this.context.$events.$emit(PLAYER_EXPIRED_CREDENTIAL_EVENT, value)
          break
        default:
          break
      }
    }
  }
  return new PlayerDelegate(context)
}

export async function playerDelegate (context, targetEl) {
  window.playerInstance && window.playerInstance.destructor && window.playerInstance.destructor()
  window.playerInstance = null
  const playerDelegateInstance = getPlayerDelegateInstance(context)
  const PlayerClass = await getPlayerClass()
  window.playerInstance = new PlayerClass(targetEl, isApollo() ? PlayerType.APOLLO : PlayerType.MOBILE, playerDelegateInstance)
  context.playerInit()
  context = null
}

export const showLoginPopup = () => {
  store.commit(SHOW_LOGIN_POPUP)
}

export const getNoneCredentialUserInfo = () => {
  return {
    credentialKey: 'none',
    GUID: getGUID(),
    clientIP: getIp(),
    userNo: 'none',
    userID: 'none',
    profileID: 'none',
    pooqzoneType: cookie.getPooqZoneType()
  }
}
